import React from "react";

function MessageBox(props) {
  return (
    <>
      <div className={`BLM-content hidden md:block`}>
        <div className={`BLM-msgBox`} data-livenowleagueid={9999}>
          <div className="BLM-msgBox-container !bg-[#6C6C6C] !text-white">{props?.data}</div>
        </div>
      </div>
    </>
  );
}

export default MessageBox;
